import Immutable from 'immutable';
import React from 'react';

import ParagraphFaq from '../../../FAQ';

import './style.scss';

const FaqOverview = ({ hits }) => {
  const items = hits.map((hit) => {
    return {
      target_id: hit.nid[0],
      // Get the Teaser JSON data from the rendered_item field.
      entity: JSON.parse(hit.rendered_item[0]).data,
    };
  });

  const data = Immutable.fromJS({
    field_title: [],
    field_body: [],
    field_faq: items,
  });

  return (
    <ParagraphFaq
      id="SearchFaqOverview"
      entity={data}
      key={`faq-overview-${hits.length}`}
    />
  );
};

export default FaqOverview;
